import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import useCart from '../../../data/hooks/cart_hook';
import { Product } from '../../../data/models/product_list_response';
import { RootState } from '../../../data/reducers';
import { getImageUrl, formatAmount } from '../../../utility/common';
import { ImageComponent } from '../common/image_component';
import { ProductVariantAddButton } from './product_variant_add_button';
import { icons } from '../../../assets/assets';
import { EditQuantityModal } from './edit_quantity_modal';

export const ProductAddButton = (props: { product: Product; isLarge?: boolean }) => {
  const { storeInfo } = useSelector((state: RootState) => state.storeReducer);
  const { isItemInCart, getItemInCart, addToCart, removeFromCart, updateCartQuantity } = useCart();
  const cartQuantity = getItemInCart(props.product.storeProductId)?.cartQuantity;
  const [updatedQuantity, setUpdatedQuantity] = useState(cartQuantity);
  const [showEditModal, setShowEditModal] = useState(false);

  useEffect(() => {
    setUpdatedQuantity(cartQuantity);
  }, [cartQuantity]);

  if (storeInfo?.pickupAvailable || storeInfo?.deliveryAvailable) {
    return !isItemInCart(props.product.storeProductId) || props.product.haveVariants ? (
      <>
        <button
          className={
            !props.isLarge
              ? 'w-full uppercase border border-primaryViolet rounded-lg px-1 py-2 text-sm text-primaryViolet hover:text-white hover:bg-primaryViolet transition-colors'
              : 'w-full uppercase border border-primaryViolet rounded-lg p-3 text-sm text-primaryViolet hover:text-white hover:bg-primaryViolet transition-colors'
          }
          onClick={() => {
            if (!props.product.haveVariants) {
              addToCart(props.product);
            } else {
              if (document != null) {
                const modal: any = document.getElementById(`addVariantModal-${props.product.storeProductId}`);
                modal.showModal();
              }
            }
          }}
        >
          Add to cart
        </button>

        <dialog id={`addVariantModal-${props.product.storeProductId}`} className="modal">
          <div className="modal-box">
            <form method="dialog">
              {/* if there is a button in form, it will close the modal */}
              <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
            </form>
            <h3 className="font-bold text-lg">Variants</h3>
            {props.product.haveVariants ? (
              props.product.productVariants.map((variants) => (
                <div key={variants.id}>
                  <figure className="flex flex-col gap-4 sm:flex-row py-4 bg-slate-100 px-4 my-4 rounded-lg  justify-between w-full items-center">
                    <div className="flex flex-row">
                      <div className="w-28 h-28 rounded-lg mx-auto flex-none">
                        <ImageComponent
                          src={getImageUrl(variants?.variantPictures ?? [])}
                          htmlClass="w-28 h-28 rounded-lg flex-none"
                          htmlAlt={variants?.variantName}
                        />
                      </div>
                      <div className="pt-2 text-left pl-4">
                        <h3 className="font-medium overflow-ellipsis line-clamp-2">
                          {props.product?.productName} {variants?.variantName}
                        </h3>
                        <p className="font-normal text-sm">{`${variants?.quantity} ${props.product?.productUnit?.productUnitName}`}</p>
                        <p className="font-medium text-primaryViolet mt-2">{`${formatAmount(
                          variants?.sellingPrice,
                        )}`}</p>
                      </div>
                    </div>
                    <div className="flex-none w-full sm:w-24">
                      <ProductVariantAddButton product={props.product} variantId={variants.id} />
                    </div>
                  </figure>
                </div>
              ))
            ) : (
              <></>
            )}
          </div>
        </dialog>
      </>
    ) : (
      <div className="">
        <div
          className={
            !props.isLarge
              ? 'flex flex-row bg-primaryViolet text-white rounded-lg p-2 text-sm'
              : 'flex flex-row bg-primaryViolet text-white rounded-lg p-3 text-sm'
          }
        >
          <button className="flex-1" onClick={() => removeFromCart(props.product, props.product.storeProductId)}>
            -
          </button>
          <button
            className="flex-1 text-white text-center"
            data-bs-toggle="modal"
            data-bs-target="#quantityEditModal"
            onClick={() => {
              setShowEditModal(true);
              // if (document != null) {
              //   const modal: any = document.getElementById('quantityEditModal-non-var');
              //   modal.showModal();
              // }
            }}
          >
            {cartQuantity}
          </button>
          <button className="flex-1" onClick={() => addToCart(props.product)}>
            +
          </button>
        </div>

        <EditQuantityModal  key={`${props.product.storeProductId}-add-product-modl`} product={props.product} isOpen={showEditModal} setShowEdit={setShowEditModal}/>
      </div>
    );
  } else {
    return <></>;
  }
};
